import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  /**
   * General message stating that the request has failed
   */
  message: PropTypes.node.isRequired,
}

/**
 * Snippet for common submission success use cases
 */
function SubmissionSuccess(props) {
  const { message } = props

  return (
    <div>
      <span className="font-color-engage fas fa-circle-check me-2" />
      <span className="text-bold">{message}</span>
    </div>
  )
}

SubmissionSuccess.propTypes = propTypes

export default SubmissionSuccess
